import React from "react";
import { FormCheck } from "react-bootstrap";
import { PLAN_TYPES } from "src/constants/subscriptionsConstants";
import styles from "./SubscriptionBillingIntervalSwitch.module.scss";

const SubscriptionBillingIntervalSwitch = ({
    planType,
    handlePlanTypeChange
}) => {
    return (
        <div className={styles.intervalSwitchContainer}>
            <label className="mr-2" htmlFor="subscription-interval">
                Monthly
            </label>
            <FormCheck
                bsCustomPrefix={"intervalSwitch"}
                type="switch"
                id="subscription-interval"
                value={planType}
                checked={planType === PLAN_TYPES.YEAR}
                onChange={(e) => handlePlanTypeChange(e)}
            />
            <label htmlFor="subscription-interval">Yearly</label>
        </div>
    );
};

export default SubscriptionBillingIntervalSwitch;
